"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageableCrudStore = exports.PageableCrudStoreHooks = void 0;
const tslib_1 = require("tslib");
const ojaat_1 = require("./ojaat");
const pageable_store_1 = require("./pageable-store");
var PageableCrudStoreHooks;
(function (PageableCrudStoreHooks) {
    PageableCrudStoreHooks["BEFORE_CREATE"] = "beforeCreate";
    PageableCrudStoreHooks["AFTER_CREATE"] = "afterCreate";
    PageableCrudStoreHooks["BEFORE_PUT"] = "beforePut";
    PageableCrudStoreHooks["AFTER_PUT"] = "afterPut";
    PageableCrudStoreHooks["BEFORE_PATCH"] = "beforePatch";
    PageableCrudStoreHooks["AFTER_PATCH"] = "afterPatch";
    PageableCrudStoreHooks["BEFORE_DELETE"] = "beforeDelete";
    PageableCrudStoreHooks["AFTER_DELETE"] = "afterDelete";
})(PageableCrudStoreHooks = exports.PageableCrudStoreHooks || (exports.PageableCrudStoreHooks = {}));
class PageableCrudStore extends pageable_store_1.PageableStore {
    constructor(options = { loadOnDeletion: true }) {
        super(options);
        this.options = options;
        this.queue = new ojaat_1.OneJobAtATimeQueue();
    }
    /**
     * Either returns a copy of the model from store or, if not found, from http
     */
    get(id, forceHttp = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (id === undefined) {
                throw new Error("id cannot be undefined");
            }
            try {
                let modelById = this.getById(id); // get local value
                if (modelById && !forceHttp)
                    return modelById;
                modelById = yield this.queue.run(id, () => this.loadModelById(id));
                if (modelById)
                    this.addValue(modelById);
                return modelById;
            }
            catch (e) {
                // not found
            }
        });
    }
    /**
     * Creates the model via http and adds it to the store (at the end)
     */
    create(model) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.executeHooks(PageableCrudStoreHooks.BEFORE_CREATE, model);
            try {
                const m = yield this.createModel(model);
                this.addValue(m);
                yield this.executeHooks(PageableCrudStoreHooks.AFTER_CREATE, m);
                return m;
            }
            catch (e) {
                this.setError(e);
                throw e;
            }
        });
    }
    /**
     * Deletes the model via http and then from the store
     */
    delete(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.executeHooks(PageableCrudStoreHooks.BEFORE_DELETE, id);
            try {
                yield this.deleteModelById(id);
                this.updateValue((value) => {
                    value = value.filter((v) => v.id !== id);
                    const currentPageIds = this.currentPageIds$.value;
                    this.currentPageIds$.next(currentPageIds.filter((cpi) => cpi !== id));
                    return value;
                });
                if (this.options.loadOnDeletion)
                    yield this.load();
                yield this.executeHooks(PageableCrudStoreHooks.AFTER_DELETE, id);
            }
            catch (e) {
                this.setError(e);
                throw e;
            }
        });
    }
    /**
     * Deletes many models via http and then from the store
     */
    deleteMany(ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            for (const id of ids)
                yield this.executeHooks(PageableCrudStoreHooks.BEFORE_DELETE, id);
            try {
                yield this.deleteModelsByIds(ids);
                this.updateValue((value) => {
                    value = value.filter((v) => !ids.includes(v.id));
                    const currentPageIds = this.currentPageIds$.value;
                    this.currentPageIds$.next(currentPageIds.filter((cpi) => !ids.includes(cpi)));
                    return value;
                });
                if (this.options.loadOnDeletion)
                    yield this.load();
                for (const id of ids)
                    yield this.executeHooks(PageableCrudStoreHooks.AFTER_DELETE, id);
            }
            catch (e) {
                this.setError(e);
                throw e;
            }
        });
    }
    /**
     * Patches the model via http and in store
     */
    patch(id, model) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.executeHooks(PageableCrudStoreHooks.BEFORE_PATCH, id, model);
            try {
                const m = yield this.patchModel(id, model);
                this.updateValue((value) => {
                    if (!value)
                        value = [];
                    const index = value.findIndex((v) => v.id === id);
                    if (index !== -1)
                        value[index] = m;
                    else
                        value.push(m);
                    return value;
                });
                yield this.executeHooks(PageableCrudStoreHooks.AFTER_PATCH, id, m);
                return m;
            }
            catch (e) {
                this.setError(e);
                throw e;
            }
        });
    }
    /**
     * Replaces the model via http and in store
     */
    put(model) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.executeHooks(PageableCrudStoreHooks.BEFORE_PUT, model);
            try {
                const m = yield this.putModel(model);
                this.updateValue((value) => {
                    if (!value)
                        value = [];
                    const index = value.findIndex((v) => v.id === model.id);
                    if (index !== -1)
                        value[index] = m;
                    else
                        value.push(m);
                    return value;
                });
                yield this.executeHooks(PageableCrudStoreHooks.AFTER_PUT, m);
                return m;
            }
            catch (e) {
                this.setError(e);
                throw e;
            }
        });
    }
    /**
     * If model has an id, it will get put, otherwise created
     */
    createOrPut(model) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (model.id)
                return this.put(model);
            else
                return this.create(model);
        });
    }
}
exports.PageableCrudStore = PageableCrudStore;
